// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__bbMPh","error":"Search_error__Y3o1_"};